import { HeroSection } from '../components/HeroSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { MonthlyRentalHighlightSection } from '../components/MonthlyRentalHighlightSection';
import { RecentOrderPrompt } from '@/features/orders/components/RecentOrderPrompt';

export const Home = () => {
    return (
        <>
            {/* SEO metadata lives in the route shell's `meta` export
                (`app/routes/$locale._index.tsx`). */}

            {/* Gentle return path for guests with a recently saved order (this device) */}
            <RecentOrderPrompt />

            {/* Hero — value prop + product preview + search */}
            <HeroSection />

            {/* How It Works — numbered 3-step process */}
            <HowItWorksSection />

            {/* Why Choose Us — editorial trust signals (safety, cleanliness, brands, flexibility) */}
            <WhyChooseUsSection />

            {/* Monthly Rental Highlight — dark teal CTA section */}
            <MonthlyRentalHighlightSection />
        </>
    );
};
